import { h, Component } from 'preact';
import Store from 'store/store';
import { smoothScrollTo } from 'utils/smoothScroll';
import { joinClasses } from 'utils/utils';
import { isPlanet, isGlyphEasterEgg, isFlightEasterEgg, isTravelerNoticesEasterEgg } from 'helpers/index.js';
import Sidebar from 'components/bolt/airport/sidebar.js';
import Clock from 'components/bolt/airport/clock.js';
import Weather from 'components/bolt/airport/weather.js';
import PopUpWindows from 'components/bolt/airport/popUpWindows/popUpWindows';
import Pipes from 'components/bolt/airport/pipes/pipes.js';
import Glyphs from 'components/bolt/airport/glyphs/glyphs.js';
import s from 'components/bolt/airport/airport.sss';
import Title from 'components/bolt/airport/title.js';
import { goesToUpWorld, isUpWorld } from '../../../helpers';

export default class Airport extends Component {

	constructor(props) {
		super(props);
		this.toggleSidebar = this.toggleSidebar.bind(this);
		this.toggleWindow = this.toggleWindow.bind(this);
		this.makeActiveWindow = this.makeActiveWindow.bind(this);
		this.setAirportCastleRects = this.setAirportCastleRects.bind(this);
		this.setSideButtonRects = this.setSideButtonRects.bind(this);
		this.onWindowResize = this.onWindowResize.bind(this);
		this.onRobPlanetClick = this.onRobPlanetClick.bind(this);
		this.onOpenEasterEgg = this.onOpenEasterEgg.bind(this);
		this.onLogoClick = this.onLogoClick.bind(this);
		this.state = {
			sidebarOpen: false,
			castleRect: {},
			airportRect: {},
			sideButtonRects: {},
			openedWindows: []
		};
	}


	componentDidMount() {
		window.addEventListener('resize', this.onWindowResize);
		Store.on('UPDATE_PLANET_OVERLAY', this.onRobPlanetClick);
		Store.on('OPEN_EASTER_EGG', this.onOpenEasterEgg);
		Store.on('SCROLL_TO_UPWORLD', this.scrollToUpWorld);
		Store.on('OPEN_WATCH_AT_HOME', (id) => this.toggleWindow(id));
	}

	componentDidUpdate(prevProps) {
		if (prevProps.introOpen !== this.props.introOpen) {
			this.setAirportCastleRects();
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onWindowResize);
		Store.off('UPDATE_PLANET_OVERLAY', this.onRobPlanetClick);
		Store.off('OPEN_EASTER_EGG', this.onOpenEasterEgg);
		Store.off('SCROLL_TO_UPWORLD', this.scrollToUpWorld);
		Store.off('OPEN_WATCH_AT_HOME', this.toggleWindow);
	}

	onWindowResize() {
		this.setAirportCastleRects();
	}

	scrollToUpWorld() {
		const scrollEaseOut = (x) => Math.sqrt(1 - Math.pow(x - 1, 2));
		smoothScrollTo(document.getElementById('mainScroll'), 0, 1500, { easing: scrollEaseOut });
	}

	onLogoClick() {
		this.scrollToUpWorld();

		Store.emit('CUSTOM_EVENT', {
			category: 'central-navigation',
			action: 'gateway-galaxy-click',
		});

	}

	onRobPlanetClick(planetId) {
		const { openedWindows } = this.state;
		if (isPlanet(planetId)) {
			if (openedWindows.includes(planetId)) {
				this.makeActiveWindow(planetId);
				return;
			}
			this.toggleWindow(planetId);
		} else if (goesToUpWorld(planetId)) {
			Store.emit('SCROLL_TO_UPWORLD');
		} else if (isFlightEasterEgg(planetId)) {
			this.toggleWindow(planetId);
		}
	}

	onOpenEasterEgg(id) {
		const { openedWindows } = this.state;
		if (!isGlyphEasterEgg(id) && !isFlightEasterEgg(id) && !isTravelerNoticesEasterEgg(id)) return;
		if (openedWindows.includes(id)) {
			this.makeActiveWindow(id);
			return;
		}
		this.toggleWindow(id);
	}

	toggleSidebar() {
		if	(this.state.sidebarOpen && this.props.legalsOpen) {
			this.props.toggleLegals();
		}
		this.setState({ sidebarOpen: !this.state.sidebarOpen });
		Store.emit('PLAY_SOUND', 'toggleSidebar');
	}

	setAirportCastleRects() {
		if (!this.$castle || !this.$airportContainer) return;
		const airportRect = this.$airportContainer.getBoundingClientRect();
		const { top: airportTop, y: airportY, x: airportX, left: airportLeft, width: airportWidth, height: airportHeight } = airportRect;
		const rect = this.$castle.getBoundingClientRect();
		const { x, y, top, left, width, height } = rect;
		const castleY = y - airportY;
		const castleTop = top - airportTop;
		this.setState({
			castleRect: { x, y: castleY, top: castleTop, left, width, height },
			airportRect: { x: airportX, y: airportY, top: airportTop, left: airportLeft, width: airportWidth, height: airportHeight }
		});
	}

	setSideButtonRects(rects) {
		this.setState({ sideButtonRects: rects });
	}

	toggleWindow(id) {
		const { openedWindows } = this.state;
		if (openedWindows.includes(id)) {
			Store.emit('ROB_UPDATE', `${id}_closed`);
			this.setState({ openedWindows: openedWindows.filter(windowId => windowId !== id) });
		} else {
			Store.emit('ROB_UPDATE', id);
			let currentWindows = [...openedWindows];
			if (isPlanet(id)) {
				// Close any open planet windows before opening a new one
				currentWindows = currentWindows.filter(windowId => {
					if (isPlanet(windowId)) {
						Store.emit('ROB_UPDATE', `${windowId}_closed`);
						return false;
					}
					return true;
				});
			}
			this.setState({ openedWindows: [...currentWindows, id] });
		}
	}

	makeActiveWindow(id) {
		const { openedWindows } = this.state;
		if (!openedWindows.includes(id)) return;
		const filteredWindows = openedWindows.filter(windowId => windowId !== id);
		this.setState({ openedWindows: [...filteredWindows, id] });
	}


	renderHeader() {
		const { imageRoot, videoRoot, copy, motionPaused } = this.props;

		return (
			<div class={joinClasses(s.header, motionPaused && s.motionPaused)}>
				<div class={s.logoContainer}>
					<button
						class={s.logoBtn}
						onClick={this.onLogoClick}
					>
						<img class={s.logo} src={`${imageRoot}/airport/header/mk3fo3.webp`} />
						<div class={s.headerLines} />
						<div class={s.logoShine} />
						{copy.$title === 'Gateway Galaxy' ? 
							<Title /> : <h1 class={s.title} dangerouslySetInnerHTML={{ __html: copy.$title }} />
						}
					</button>
				</div>
				<Clock imageRoot={imageRoot} />
				<Weather imageRoot={imageRoot} videoRoot={videoRoot} copy={copy} motionPaused={motionPaused} />
			</div>
		);
	}

	renderCastleContainer() {
		const { imageRoot, videoRoot, client, motionPaused } = this.props;
		const { sidebarOpen, openedWindows } = this.state;
		return (
			<div class={joinClasses(s.castleContainer, sidebarOpen && s.sidebarOpen)}>
				<img
					class={s.castle}
					src={`${imageRoot}/airport/rnaszc.webp`}
					ref={($ref) => this.$castle = $ref}
					onLoad={this.setAirportCastleRects}
				/>
				<Pipes
					sidebarOpen={sidebarOpen}
					imageRoot={imageRoot}
					toggleWindow={this.toggleWindow}
					makeActiveWindow={this.makeActiveWindow}
					openedWindows={openedWindows}
					scrollToUpWorld={this.scrollToUpWorld}
				/>
				<Glyphs
					imageRoot={imageRoot}
					videoRoot={videoRoot}
					client={client}
					motionPaused={motionPaused}
				/>
				<img class={s.linesOverlay} src={`${imageRoot}/airport/bj9zfm.webp`} />
			</div>
		);
	}

	renderBottomUI() {
		const { imageRoot } = this.props;
		const { sidebarOpen } = this.state;
		return (
			<div class={s.bottomUIContainer}>
				<button class={joinClasses(s.panelOpener, sidebarOpen && s.open)} onClick={this.toggleSidebar}>
					<img class={s.plusIcon} src={`${imageRoot}/airport/plus.webp`} />
					<img class={s.minusIcon} src={`${imageRoot}/airport/minus.webp`} />
				</button>
			</div>
		);
	}

	render() {
		const { imageRoot, imageRegionRoot, videoRoot, videoRegionRoot, client, muted, motionPaused, legalsOpen, toggleMute, toggleMotion, toggleLegals, currentPage, downWorldFound, copy } = this.props;
		const { sidebarOpen, castleRect, airportRect, openedWindows, sideButtonRects } = this.state;

		return (
			<div class={joinClasses(s.container, downWorldFound && s.hide)} id ="airport-container" ref={ref => this.$airportContainer = ref}>
				{this.renderHeader()}
				{this.renderCastleContainer()}
				<Sidebar
					castleRect={castleRect}
					airportRect={airportRect}
					imageRoot={imageRoot}
					videoRoot={videoRoot}
					isOpen={sidebarOpen}
					client={client}
					toggleWindow={this.toggleWindow}
					openedWindows={openedWindows}
					setSideButtonRects={this.setSideButtonRects}
					muted={muted}
					motionPaused={motionPaused}
					legalsOpen={legalsOpen}
					toggleMute={toggleMute}
					toggleMotion={toggleMotion}
					toggleLegals={toggleLegals}
					currentPage={currentPage}
					copy={copy}
				/>
				<PopUpWindows
					openedWindows={openedWindows}
					toggleWindow={this.toggleWindow}
					makeActiveWindow={this.makeActiveWindow}
					imageRoot={imageRoot}
					client={client}
					videoRoot={videoRoot}
					videoRegionRoot={videoRegionRoot}
					imageRegionRoot={imageRegionRoot}
					sideButtonRects={sideButtonRects}
					castleRect={castleRect}
				/>
				{this.renderBottomUI()}
			</div>
		);
	}
}
